export const baseURL = process.env.REACT_APP_BASE_API;
export const isDevelopment = process.env.NODE_ENV === 'development';
